var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconControl64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_16529)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 8.50269C45.2548 8.50269 56 19.2479 56 32.5027C56 45.7575 45.2548 56.5027 32 56.5027C18.7452 56.5027 8 45.7575 8 32.5027C8 19.2479 18.7452 8.50269 32 8.50269ZM50.4681 37.3023L44.8025 37.3027C39.3708 37.3027 34.9675 41.7051 34.9675 47.1459L34.9686 51.35C42.5065 50.1723 48.5818 44.5808 50.4681 37.3023ZM28.1841 51.1979L28.1846 47.1459C28.1846 41.7097 23.7703 37.3027 18.3467 37.3027L13.5319 37.3023C15.347 44.306 21.0408 49.7477 28.1841 51.1979ZM32 13.4258C23.3904 13.4258 16.113 19.1291 13.7396 26.9637H50.2604C47.887 19.1291 40.6096 13.4258 32 13.4258Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 38.948C34.5045 38.948 36.5346 36.9178 36.5346 34.4136C36.5346 31.9093 34.5045 29.8792 32.0002 29.8792C29.4959 29.8792 27.4658 31.9093 27.4658 34.4136C27.4658 36.9178 29.4959 38.948 32.0002 38.948Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_16529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconControl64);
export default __webpack_public_path__ + "static/media/pictogramBeaconControl64.ec845cd46dbb3ab85b5f512a856b4d81.svg";
export { ForwardRef as ReactComponent };